import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { LotePresupuesto } from "../models/entities/lote-presupuesto";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { database } from "firebase";

@Injectable({
  providedIn: "root",
})
export class LotePresupuestoService {
  public CAMINOS_RURALES: string = "0";
  public CARRETERAS_FEDERALES: string = "1";
  public path: string;
  public constructor(public angularFireDatabase: AngularFireDatabase) {
    this.path = "lotesPresupuestos";
  }

  public async save(lotePresupuesto: LotePresupuesto): Promise<any> {
    if (lotePresupuesto.keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
      let lotePresupuestoEncontrado: LotePresupuesto =
        await this.findByKeyCatDireccion(lotePresupuesto.keyCatDireccionAdjunta)
          .pipe(take(1))
          .toPromise();
      if (!lotePresupuestoEncontrado) {
        return this.angularFireDatabase
          .list<LotePresupuesto>(this.path)
          .push(lotePresupuesto);
      } else {
        return this.angularFireDatabase
          .list<LotePresupuesto>(this.path)
          .set(lotePresupuestoEncontrado.key, lotePresupuesto);
      }
    } else if (
      lotePresupuesto.keyCatDireccionAdjunta === this.CARRETERAS_FEDERALES
    ) {
      let lotePresupuestoEncontrado: LotePresupuesto =
        await this.findByKeyCatDireccion(lotePresupuesto.keyCatDireccionAdjunta)
          .pipe(take(1))
          .toPromise();
      if (!lotePresupuestoEncontrado) {
        return this.angularFireDatabase
          .list<LotePresupuesto>(this.path)
          .push(lotePresupuesto);
      } else {
        return this.angularFireDatabase
          .list<LotePresupuesto>(this.path)
          .set(lotePresupuestoEncontrado.key, lotePresupuesto);
      }
    }
  }

  public findByKeyCatDireccion(
    keyCatDireccionAdjunta: string
  ): Observable<LotePresupuesto> {
    return this.angularFireDatabase
      .list<LotePresupuesto>(this.path, (ref: database.Reference) =>
        ref
          .orderByChild("keyCatDireccionAdjunta")
          .equalTo(keyCatDireccionAdjunta)
      )
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as LotePresupuesto)
          )
        ),
        map((lotesPresupuestos: LotePresupuesto[]) => lotesPresupuestos[0])
      );
  }

  public update(
    keyLotePresupuesto: string,
    lotePresupuesto: LotePresupuesto
  ): Promise<any> {
    return this.angularFireDatabase
      .list<LotePresupuesto>(this.path)
      .update(keyLotePresupuesto, lotePresupuesto);
  }

  public remove(keyLotePresupuesto: string): Promise<any> {
    return this.angularFireDatabase
      .list<LotePresupuesto>(this.path)
      .remove(keyLotePresupuesto);
  }

  public findByKey(keyLotePresupuesto: string): Observable<LotePresupuesto> {
    return this.angularFireDatabase
      .object<LotePresupuesto>(this.path + "/" + keyLotePresupuesto)
      .snapshotChanges()
      .pipe(
        map(
          (c) =>
            ({
              key: c.payload.key,
              ...c.payload.val(),
            } as LotePresupuesto)
        )
      );
  }

  public findAll(): Observable<LotePresupuesto[]> {
    return this.angularFireDatabase
      .list<LotePresupuesto>(this.path)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map(
            (c) =>
              ({
                key: c.payload.key,
                ...c.payload.val(),
              } as LotePresupuesto)
          )
        )
      );
  }
}
